import styled from 'styled-components';

import {ms} from '../../styles/normalizeSize';
import {getColor} from '../../styles/utils';
import {Text} from '../../uikit/Text';
import {View} from '../../uikit/View';

export const Container = styled(View)`
  flex-direction: column;
  row-gap: ${ms(14)};
`;

export const Title = styled(Text).attrs({
  variant: 'subtitle',
  weight: 'bold',
})``;

export const RuleContainer = styled(View)`
  flex-direction: row;
`;

export const Bullet = styled(View)`
  width: ${ms(8)};
  height: ${ms(8)};
  min-width: ${ms(8)};
  min-height: ${ms(8)};
  border-radius: ${ms(4)};
  background-color: ${getColor('global1')};
  position: relative;
  top: ${ms(6)};
  margin-left: ${ms(6)};
  margin-right: ${ms(16)};
`;

export const RuleText = styled(Text)`
  flex: 1;
`;
